import { forwardRef } from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { useTableStyles } from '../TableStylesContext';
import { getClassName } from './className';

export type TableFooterProps = BoxProps;

/**
 * A Table subcomponent used to contain elements below the Table's grid.
 * - Place within the Table after the TableHeader and TableContent.
 * - Wraps a Chakra-UI Box and responds to Table's size.
 */
export const TableFooter = forwardRef<TableFooterProps, 'div'>(
  ({ children, className, ...restProps }, ref) => {
    const { footer: footerStyles } = useTableStyles() ?? {};

    return (
      <Box
        ref={ref}
        __css={footerStyles}
        className={cx(getClassName('footer'), className)}
        {...restProps}
      >
        {children}
      </Box>
    );
  },
);
TableFooter.displayName = 'TableFooter';
